import { type PropsWithChildren, type ReactNode, useState } from "react"

import { Breadcrumbs } from "@/components/breadcrumbs"
import { IconNav } from "@/components/icon-nav"
import { MobileDrawer } from "@/components/mobile-drawer"
import { MobileTabBar } from "@/components/mobile-tab-bar"
import { MobileTopNav } from "@/components/mobile-top-nav"
import { SecondaryNav } from "@/components/secondary-nav"
import { TopNav } from "@/components/top-nav"
import type { BreadcrumbItem } from "@/types"

export default function AppTopNavLayout({
  children,
  breadcrumbs = [],
  topBar,
}: PropsWithChildren<{
  breadcrumbs?: BreadcrumbItem[]
  topBar?: ReactNode
}>) {
  const [drawerOpen, setDrawerOpen] = useState(false)

  return (
    <div className="flex h-screen flex-col overflow-hidden">
      {/* Desktop top nav */}
      <div className="hidden md:block">
        <TopNav />
      </div>
      {/* Mobile top nav */}
      <div className="md:hidden">
        <MobileTopNav onOpenDrawer={() => setDrawerOpen(true)} />
      </div>

      <div className="flex flex-1 overflow-hidden">
        {/* Desktop sidebars */}
        <div className="hidden md:contents">
          <IconNav />
          <SecondaryNav />
        </div>

        <main className="flex-1 overflow-y-auto pb-16 md:pb-0">
          {topBar ? (
            <div className="border-hpi-light-gray border-b bg-white px-6 py-2 print:hidden">
              {topBar}
            </div>
          ) : breadcrumbs.length > 0 ? (
            <div className="border-hpi-light-gray border-b bg-white px-6 py-2 print:hidden">
              <Breadcrumbs breadcrumbs={breadcrumbs} />
            </div>
          ) : null}
          {children}
        </main>
      </div>

      {/* Mobile bottom tab bar */}
      <div className="md:hidden">
        <MobileTabBar />
      </div>

      {/* Mobile drawer (renders in portal, only visible when open) */}
      <MobileDrawer open={drawerOpen} onOpenChange={setDrawerOpen} />
    </div>
  )
}
